import {
  put, takeLatest, all, select,
} from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import MrpV2Actions, { mrpV2ActionTypes } from '@Actions/production/mrpV2Actions';
import MrpV2Services from '../../services/production/mrpV2Services';

// create mrp v2
function* _createMrpV2(action) {
  try {
    yield put(MrpV2Actions.createMrpV2Loading(true));
    const {
      payload, callback,
    } = action;
    const mrp = yield MrpV2Services.createMrpV2(payload);
    if (mrp.success) {
      notification.open({
        type: 'success',
        message: 'Material Requirement Plan created successfully.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(mrp);
      }
    } else {
      notification.open({
        type: 'error',
        message: mrp?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.createMrpV2Loading(false));
  } catch (error) {
    yield put(MrpV2Actions.createMrpV2Loading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.CREATE_MRP_V2.ERROR, error));
  }
}

function* createMrpV2() {
  yield takeLatest(mrpV2ActionTypes.CREATE_MRP_V2.REQUEST, _createMrpV2);
}

// get mrp v2
function* _getMrpV2(action) {
  try {
    yield put(MrpV2Actions.getMrpV2Loading(true));
    const {
      payload, callback,
    } = action;
    const { tenantId, listScreen, mrpId, searchKeyword, status, fromDate, toDate, page, limit, } = payload;
    const mrp = yield MrpV2Services.getMrpV2(tenantId, listScreen, mrpId, searchKeyword, status, fromDate, toDate, page, limit);
    yield put(MrpV2Actions.getMrpV2Success(listScreen ? mrp : mrp?.mrp_plans?.[0]));
    if (callback) callback(mrp?.mrp_plans?.[0]);
    yield put(MrpV2Actions.getMrpV2Loading(false));
  } catch (error) {
    yield put(MrpV2Actions.getMrpV2Loading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.GET_MRP_V2.ERROR, error));
  }
}

function* getMrpV2() {
  yield takeLatest(mrpV2ActionTypes.GET_MRP_V2.REQUEST, _getMrpV2);
}

// Get Production Items
function* _getProductionItems(action) {
  try {
    yield put(MrpV2Actions.getProductionItemsLoading(true));
    const {
      mrpId, callback
    } = action;
    const productionItems = yield MrpV2Services.getProductionItems(mrpId);
    yield put(MrpV2Actions.getProductionItemsSuccess(productionItems));
    if (callback) callback(productionItems?.data || []);
    yield put(MrpV2Actions.getProductionItemsLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.getProductionItemsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.GET_PRODUCTION_ITEMS.ERROR, error));
  }
}

function* getProductionItems() {
  yield takeLatest(mrpV2ActionTypes.GET_PRODUCTION_ITEMS.REQUEST, _getProductionItems);
}

// Get Stock Items
function* _getStockItems(action) {
  const {
    payload, callback
  } = action;

  try {
    yield put(MrpV2Actions.getStockItemsLoading(true, payload?.entityType));
    const stockItems = yield MrpV2Services.getStockItems(payload?.mrpId, payload?.entityType);
    if (callback) {
      callback(stockItems);
    }
    yield put(MrpV2Actions.getStockItemsSuccess(stockItems, payload?.entityType));
    yield put(MrpV2Actions.getStockItemsLoading(false, payload?.entityType));
  } catch (error) {
    yield put(MrpV2Actions.getStockItemsLoading(false, payload?.entityType));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.GET_STOCK_ITEMS.ERROR, error));
  }
}

function* getStockItems() {
  yield takeLatest(mrpV2ActionTypes.GET_STOCK_ITEMS.REQUEST, _getStockItems);
}
// link so to Mrp

function* _LinkSoToMRP(action) {
  try {
    yield put(MrpV2Actions.LinkSoToMRPLoading(true));
    const {
      payload, callback,
    } = action;
    const state = yield select();
    const { user } = state?.UserReducers;
    const salesOrderUIName = user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.ui_name || 'Sales Order';
    const so = yield MrpV2Services.LinkSoToMRP(payload);
    if (so.success) {
      notification.open({
        type: 'success',
        message: `${salesOrderUIName} linked to Material Requirement Plan successfully.`,
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(so);
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.LinkSoToMRPLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.LinkSoToMRPLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.LINK_SO_TO_MRP.ERROR, error));
  }
}

function* LinkSoToMRP() {
  yield takeLatest(mrpV2ActionTypes.LINK_SO_TO_MRP.REQUEST, _LinkSoToMRP);
}

// Push To Production Items
function* _pushToProductionItems(action) {
  try {
    yield put(MrpV2Actions.pushToProductionItemsLoading(true));
    const {
      payload, callback,
    } = action;
    const items = yield MrpV2Services.pushToProductionItems(payload);
    if (items.success) {
      notification.open({
        type: 'success',
        message: 'Items sucessfully pushed to production items.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(items);
      }
    } else {
      notification.open({
        type: 'error',
        message: mrp?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.pushToProductionItemsLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.pushToProductionItemsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.PUSH_TO_PRODUCTION_ITEMS.ERROR, error));
  }
}

function* pushToProductionItems() {
  yield takeLatest(mrpV2ActionTypes.PUSH_TO_PRODUCTION_ITEMS.REQUEST, _pushToProductionItems);
}

// Push To Stock Items
function* _pushToStockItems(action) {
  try {
    yield put(MrpV2Actions.pushToStockItemsLoading(true));
    const {
      payload, callback,
    } = action;
    const item = yield MrpV2Services.pushToStockItems(payload);
    if (item.success) {
      notification.open({
        type: 'success',
        message: 'Item sucessfully pushed to stock items.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(item);
      }
    } else {
      notification.open({
        type: 'error',
        message: item?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.pushToStockItemsLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.pushToStockItemsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.PUSH_TO_STOCK_ITEMS.ERROR, error));
  }
}

function* pushToStockItems() {
  yield takeLatest(mrpV2ActionTypes.PUSH_TO_STOCK_ITEMS.REQUEST, _pushToStockItems);
}

// update Mrp v2
function* _updateMrpV2(action) {
  try {
    yield put(MrpV2Actions.updateMrpV2Loading(true));
    const {
      payload, callback,
    } = action;
    const mrp = yield MrpV2Services.updateMrpV2(payload);
    if (mrp.success) {
      notification.open({
        type: 'success',
        message: 'Material Requirement Plan updated successfully.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(mrp);
      }
    } else {
      notification.open({
        type: 'error',
        message: mrp?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.updateMrpV2Loading(false));
  } catch (error) {
    yield put(MrpV2Actions.updateMrpV2Loading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.UPDATE_MRP_V2.ERROR, error));
  }
}

function* updateMrpV2() {
  yield takeLatest(mrpV2ActionTypes.UPDATE_MRP_V2.REQUEST, _updateMrpV2);
}

// Update MRP Production
function* _updateMrpProduction(action) {
  try {
    yield put(MrpV2Actions.updateMrpProductionLoading(true));
    const {
      payload, callback,
    } = action;
    const mrp = yield MrpV2Services.updateMrpProduction(payload);
    if (mrp.success) {
      notification.open({
        type: 'success',
        message: 'Material Requirement Plan updated successfully.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(mrp);
      }
    } else {
      notification.open({
        type: 'error',
        message: mrp?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.updateMrpProductionLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.updateMrpProductionLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.UPDATE_MRP_PRODUCTION.ERROR, error));
  }
}

function* updateMrpProduction() {
  yield takeLatest(mrpV2ActionTypes.UPDATE_MRP_PRODUCTION.REQUEST, _updateMrpProduction);
}

// Get Stock Items
function* _getLinkedMO(action) {
  try {
    yield put(MrpV2Actions.getLinkedMOLoading(true));
    const {
      payload
    } = action;
    const linkedMO = yield MrpV2Services.getLinkedMO(payload?.mrpId);
    yield put(MrpV2Actions.getLinkedMOSuccess(linkedMO));
    yield put(MrpV2Actions.getLinkedMOLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.getLinkedMOLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.GET_LINKED_MO.ERROR, error));
  }
}

function* getLinkedMO() {
  yield takeLatest(mrpV2ActionTypes.GET_LINKED_MO.REQUEST, _getLinkedMO);
}

// update MRP Stock Items

function* _updateMrpStockItems(action) {
  try {
    yield put(MrpV2Actions.updateMrpStockItemsLoading(true));
    const {
      payload, callback,
    } = action;
    const mrp = yield MrpV2Services.updateMrpStockItems(payload);
    if (mrp.success) {
      notification.open({
        type: 'success',
        message: 'Material Requirement Plan updated successfully.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(mrp);
      }
    } else {
      notification.open({
        type: 'error',
        message: mrp?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.updateMrpStockItemsLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.updateMrpStockItemsLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.UPDATE_MRP_STOCK_ITEMS.ERROR, error));
  }
}

function* updateMrpStockItems() {
  yield takeLatest(mrpV2ActionTypes.UPDATE_MRP_STOCK_ITEMS.REQUEST, _updateMrpStockItems);
}

// Link Mo to Mrp
function* _linkMoToMrp(action) {
  try {
    yield put(MrpV2Actions.linkMoToMrpLoading(true));
    const {
      payload, callback,
    } = action;
    const mo = yield MrpV2Services.linkMoToMrp(payload);
    if (mo.success) {
      notification.open({
        type: 'success',
        message: 'Manufacturing Order linked to Material Requirement Plan successfully.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(mo);
      }
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.linkMoToMrpLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.linkMoToMrpLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.LINK_MO_TO_MRP.ERROR, error));
  }
}

function* linkMoToMrp() {
  yield takeLatest(mrpV2ActionTypes.LINK_MO_TO_MRP.REQUEST, _linkMoToMrp);
}
function* _linkPoToMrp(action) {
  try {
    yield put(MrpV2Actions.linkPoToMrpLoading(true));
    const {
      payload, callback,
    } = action;
    const po = yield MrpV2Services.linkPoToMrp(payload);
    if (po.success) {
      notification.open({
        type: 'success',
        message: 'Purchase Order linked to Material Requirement Plan successfully.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(po);
      }
    } else {
      notification.open({
        type: 'error',
        message: po?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.linkPoToMrpLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.linkPoToMrpLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.LINK_PO_TO_MRP.ERROR, error));
  }
}

function* linkPoToMrp() {
  yield takeLatest(mrpV2ActionTypes.LINK_PO_TO_MRP.REQUEST, _linkPoToMrp);
}

// unlink so to Mrp
function* _unlinkSoToMRP(action) {
  try {
    yield put(MrpV2Actions.unlinkSoToMrpLoading(true));
    const {
      payload, callback,
    } = action;

    const state = yield select();
    const { user } = state?.UserReducers;
    const salesOrderUIName = user?.tenant_info?.sales_config?.sub_modules?.sales_order?.settings?.ui_name || 'Sales Order';
    const so = yield MrpV2Services.unlinkSoToMRP(payload);
    if (so.success) {
      notification.open({
        type: 'success',
        message: `${salesOrderUIName} unlinked from Material Requirement Plan successfully.`,
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(so);
      }
    } else {
      notification.open({
        type: 'error',
        message: so?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.unlinkSoToMrpLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.unlinkSoToMrpLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.UNLINK_SO_TO_MRP.ERROR, error));
  }
}

function* unlinkSoToMRP() {
  yield takeLatest(mrpV2ActionTypes.UNLINK_SO_TO_MRP.REQUEST, _unlinkSoToMRP);
}

// Reserve Shortage
function* _reserveShortageMrp(action) {
  try {
    yield put(MrpV2Actions.reserveShortageMrpLoading(true));
    const {
      payload, callback,
    } = action;
    const reserveShortage = yield MrpV2Services.reserveShortageMrp(payload);
    if (reserveShortage.success) {
      notification.open({
        type: 'success',
        message: 'All the batches are reserved successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(reserveShortage);
      }
    } else {
      notification.open({
        type: 'error',
        message: reserveShortage?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.reserveShortageMrpLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.reserveShortageMrpLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.RESERVE_SHORTAGE.ERROR, error));
  }
}

function* reserveShortageMrp() {
  yield takeLatest(mrpV2ActionTypes.RESERVE_SHORTAGE.REQUEST, _reserveShortageMrp);
}

// unlink mo to Mrp
function* _unlinkMoToMRP(action) {
  try {
    yield put(MrpV2Actions.unlinkMoToMrpLoading(true));
    const {
      payload, callback,
    } = action;
    const mo = yield MrpV2Services.unlinkMoToMRP(payload);
    if (mo.success) {
      notification.open({
        type: 'success',
        message: 'Manufacturing Order unlinked from Material Requirement Plan successfully.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(mo);
      }
    } else {
      notification.open({
        type: 'error',
        message: mo?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.unlinkMoToMrpLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.unlinkMoToMrpLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.UNLINK_MO_TO_MRP.ERROR, error));
  }
}

function* unlinkMoToMRP() {
  yield takeLatest(mrpV2ActionTypes.UNLINK_MO_TO_MRP.REQUEST, _unlinkMoToMRP);
}
function* _unlinkPoToMRP(action) {
  try {
    yield put(MrpV2Actions.unlinkPoToMrpLoading(true));
    const {
      payload, callback,
    } = action;
    const po = yield MrpV2Services.unlinkPoToMRP(payload);
    if (po.success) {
      notification.open({
        type: 'success',
        message: 'Purchase Orders unlinked from Material Requirement Plan successfully.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(po);
      }
    } else {
      notification.open({
        type: 'error',
        message: po?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.unlinkPoToMrpLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.unlinkPoToMrpLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.UNLINK_PO_TO_MRP.ERROR, error));
  }
}

function* unlinkPoToMRP() {
  yield takeLatest(mrpV2ActionTypes.UNLINK_PO_TO_MRP.REQUEST, _unlinkPoToMRP);
}

// close mrp plan
function* _closeMrpPlan(action) {
  try {
    yield put(MrpV2Actions.closeMrpPlanLoading(true));
    const {
      payload, callback,
    } = action;
    const mrp = yield MrpV2Services.closeMrpPlan(payload);
    if (mrp.success) {
      notification.open({
        type: 'success',
        message: 'Material Requirement Plan closed successfully.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(mrp);
      }
    } else {
      notification.open({
        type: 'error',
        message: mrp?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.closeMrpPlanLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.closeMrpPlanLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.CLOSE_MRP_PLAN.ERROR, error));
  }
}

function* closeMrpPlan() {
  yield takeLatest(mrpV2ActionTypes.CLOSE_MRP_PLAN.REQUEST, _closeMrpPlan);
}

function* _getMrpSummary(action) {
  try {
    yield put(MrpV2Actions.getMrpSummaryLoading(true));
    const {
      payload, callback,
    } = action;
    const mrpSummary = yield MrpV2Services.getMrpSummary(payload?.mrpId);
    if (mrpSummary.error) {
      notification.open({
        type: 'error',
        message: mrpSummary?.message,
        duration: 4,
        placement: 'top',
      });
    } else {
      yield put(MrpV2Actions.getMrpSummarySuccess(mrpSummary));
      if (callback) {
        callback();
      }
    }
    yield put(MrpV2Actions.getMrpSummaryLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.getMrpSummaryLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getMrpSummary() {
  yield takeLatest(mrpV2ActionTypes.GET_MRP_SUMMARY.REQUEST, _getMrpSummary);
}

// Clear Reservation
function* _clearReservation(action) {
  try {
    yield put(MrpV2Actions.clearReservationLoading(true));
    const {
      payload, callback,
    } = action;
    const clearReservation = yield MrpV2Services.clearReservation(payload);
    if (clearReservation.success) {
      notification.open({
        type: 'success',
        message: 'All the batches are unreserved successfully',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback(clearReservation);
      }
    } else {
      notification.open({
        type: 'error',
        message: clearReservation?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.clearReservationLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.clearReservationLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.CLEAR_RESERVATION.ERROR, error));
  }
}

function* clearReservation() {
  yield takeLatest(mrpV2ActionTypes.CLEAR_RESERVATION.REQUEST, _clearReservation);
}

function* _deleteMrpV2(action) {
  try {
    yield put(MrpV2Actions.deleteMrpV2Loading(true));
    const {
      payload, callback,
    } = action;
    const deletedReservation = yield MrpV2Services.deleteMrpV2(payload?.mrpId);
    if (deletedReservation.success) {
      notification.open({
        type: 'success',
        message: 'Materials plan has been deleted.',
        duration: 4,
        placement: 'top',
      });
      if (callback) {
        callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: deletedReservation?.error,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.deleteMrpV2Loading(false));
  } catch (error) {
    yield put(MrpV2Actions.deleteMrpV2Loading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* deleteMrpV2() {
  yield takeLatest(mrpV2ActionTypes.DELETE_MRP_V2.REQUEST, _deleteMrpV2);
}

// link existing po to mrp
function* _getLinkExistingPoToMrp(action) {
  try {
    yield put(MrpV2Actions.getLinkExistingPoToMrpLoading(true));
    const {
      payload, callback,
    } = action;
    const po = yield MrpV2Services.getLinkExistingPoToMrp(payload);
    if (po.success) {
      yield put(MrpV2Actions.getLinkExistingPoToMrpSuccess(po?.data));
      if (callback) {
        callback(po?.data);
      }
    } else {
      notification.open({
        type: 'error',
        message: po?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.getLinkExistingPoToMrpLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.getLinkExistingPoToMrpLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.GET_LINK_EXISTING_PO_TO_MRP.ERROR, error));
  }
}

function* getLinkExistingPoToMrp() {
  yield takeLatest(mrpV2ActionTypes.GET_LINK_EXISTING_PO_TO_MRP.REQUEST, _getLinkExistingPoToMrp);
}

function* _linkExistingPoToMrp(action) {
  try {
    yield put(MrpV2Actions.LinkExistingPoToMrpV2Loading(true));
    const {
      payload, callback,
    } = action;
    const po = yield MrpV2Services.LinkExistingPoToMrp(payload);
    if (po.success) {
      if (callback) {
        notification.open({
          type: 'success',
          message: po?.message,
          duration: 4,
          placement: 'top',
        });
        callback(po?.data);
      }
    } else {
      notification.open({
        type: 'error',
        message: po?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.LinkExistingPoToMrpV2Loading(false));
  } catch (error) {
    yield put(MrpV2Actions.LinkExistingPoToMrpV2Loading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.LINK_EXISTING_PO_TO_MRP.ERROR, error));
  }
}

function* linkExistingPoToMrp() {
  yield takeLatest(mrpV2ActionTypes.LINK_EXISTING_PO_TO_MRP.REQUEST, _linkExistingPoToMrp);
}

function* _getAlreadyLinkedPoToMrp(action) {
  try {
    yield put(MrpV2Actions.getAlreadyLinkedPoToMrpLoading(true));
    const {
      payload, callback,
    } = action;
    const po = yield MrpV2Services.getAlreadyLinkedPoToMrp(payload);
    if (po.success) {
      yield put(MrpV2Actions.getAlreadyLinkedPoToMrpSuccess(po?.data));
      if (callback) {
        callback(po?.data);
      }
    } else {
      notification.open({
        type: 'error',
        message: po?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.getAlreadyLinkedPoToMrpLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.getAlreadyLinkedPoToMrpLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.GET_ALREADY_LINKED_PO_TO_MRP.ERROR, error));
  }
}

function* getAlreadyLinkedPoToMrp() {
  yield takeLatest(mrpV2ActionTypes.GET_ALREADY_LINKED_PO_TO_MRP.REQUEST, _getAlreadyLinkedPoToMrp);
}

function* _unlinkLinkedPoToMrp(action) {
  try {
    yield put(MrpV2Actions.unlinkLinkedPoToMrpLoading(true));
    const {
      payload, callback,
    } = action;
    const po = yield MrpV2Services.unlinkLinkedPoToMrp(payload);
    if (po.success) {
      if (callback) {
        notification.open({
          type: 'success',
          message: po?.message,
          duration: 4,
          placement: 'top',
        });
        callback(po?.data);
      }
    } else {
      notification.open({
        type: 'error',
        message: po?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.unlinkLinkedPoToMrpLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.unlinkLinkedPoToMrpLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.UNLINK_LINKED_PO_TO_MRP.ERROR, error));
  }
}

function* unlinkLinkedPoToMrp() {
  yield takeLatest(mrpV2ActionTypes.UNLINK_LINKED_PO_TO_MRP.REQUEST, _unlinkLinkedPoToMrp);
}

function* _updateLinkedPoToMrp(action) {
  try {
    yield put(MrpV2Actions.updateLinkedPoToMrpLoading(true));
    const {
      payload, callback,
    } = action;
    const po = yield MrpV2Services.updateLinkedPoToMrp(payload);
    if (po.success) {
      if (callback) {
        notification.open({
          type: 'success',
          message: po?.message,
          duration: 4,
          placement: 'top',
        });
        callback(po?.data);
      }
    } else {
      notification.open({
        type: 'error',
        message: po?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(MrpV2Actions.updateLinkedPoToMrpLoading(false));
  } catch (error) {
    yield put(MrpV2Actions.updateLinkedPoToMrpLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(mrpV2ActionTypes.UPDATE_LINKED_PO_TO_MRP.ERROR, error));
  }
}

function* updateLinkedPoToMrp() {
  yield takeLatest(mrpV2ActionTypes.UPDATE_LINKED_PO_TO_MRP.REQUEST, _updateLinkedPoToMrp);
}
export default function* mrpV2Saga() {
  yield all([
    getMrpV2(),
    createMrpV2(),
    getProductionItems(),
    getStockItems(),
    LinkSoToMRP(),
    pushToProductionItems(),
    pushToStockItems(),
    updateMrpV2(),
    updateMrpProduction(),
    getLinkedMO(),
    updateMrpStockItems(),
    linkMoToMrp(),
    linkPoToMrp(),
    unlinkSoToMRP(),
    reserveShortageMrp(),
    unlinkMoToMRP(),
    unlinkPoToMRP(),
    closeMrpPlan(),
    getMrpSummary(),
    clearReservation(),
    deleteMrpV2(),
    getLinkExistingPoToMrp(),
    linkExistingPoToMrp(),
    getAlreadyLinkedPoToMrp(),
    unlinkLinkedPoToMrp(),
    updateLinkedPoToMrp(),
  ]);
}
